import { applySnapshot, flow, types } from 'mobx-state-tree';
import { AppealFile, IAppealFile } from '../types';
import { Appeals, Files } from 'http-requests';

import { AppealFileModel, NameModel } from './base';

export const CommentEmployeeModel = NameModel.props({
  _id: types.optional(types.identifier, ''),
  position_name: types.optional(types.string, ''),
}).named('CommentEmployeeModel');

export const CommentModel = types
  .model('CommentModel', {
    _id: types.optional(types.identifier, ''),
    appeal_id: types.optional(types.string, ''),
    created_at: types.optional(types.string, ''),
    text: types.optional(types.string, ''),
    files: types.optional(types.array(AppealFileModel), []),
    employee: types.optional(CommentEmployeeModel, {}),
    is_read_by_me: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    uploadFiles: flow(function* (files: Array<AppealFile>) {
      try {
        yield Promise.all(
          files
            .filter((file) => file.shared_id)
            .map(async (file) => {
              const formData = new FormData();
              formData.append('file', file.file);

              await Files.SaveFileToFilesMS(file.shared_id!, formData);
            })
        );

        return files;
      } catch (e) {
        console.error('AppealStore: CommentModel promise uploadFiles down');

        return Promise.reject(e);
      }
    }),
    read: flow(function* () {
      try {
        const response = yield Appeals.ReadComment(self.appeal_id, self._id);
        applySnapshot(self, response);

        return response;
      } catch (error) {
        console.error(error);

        throw error;
      }
    }),
    downloadFile: flow(function* (file: IAppealFile) {
      try {
        if (!file.shared_id) {
          throw new Error('Не удалось скачать файл');
        }

        file.downloadStatus.loadingStates();
        const response = yield Files.GetFileFromFilesMS(file.shared_id);

        const blob = yield response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', file.name);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        file.downloadStatus.successStates();

        return response;
      } catch (error) {
        file.downloadStatus.errorStates();
        console.error(error);

        throw error;
      } finally {
        file.downloadStatus.finallyStates();
      }
    }),
  }));
